export enum SliderTitles {
  LEARN_MORE = 'Learn more',
  LANDSCAPES_BTN = 'Captivating Landscapes of Catalonia',
  CATALUNYA = 'Catalunya',
}
